module.exports = __webpack_public_path__ + "media/images/university_logos/Imperial-College-of-London-e4ecb9dd5714e716eb4cdb75c9213b5e.svg";